import type {InputProps, RefProp} from 'src/types/react';

import * as React from 'react';

import classify from 'src/utils/classify';

import ErrorList from 'src/components/lib/error-list';

import css from './error-input.css';


type ErrorProps = InputProps & {
  errors: string[] | undefined;
  className?: string;
  textAreaClassName?: string;
};

const ErrorTextarea = ({
  className,
  textAreaClassName,
  // @ts-expect-error - TS2322 - Type 'never[]' is not assignable to type 'never'.
  errors = [],
  // @ts-expect-error - TS2700 - Rest types may only be created from object types.
  ...props
}: ErrorProps): React.ReactElement<React.ComponentProps<'div'>> => (
  <div className={classify(css.container, className)}>
    <textarea
      className={classify(
        // @ts-expect-error - TS2339 - Property 'length' does not exist on type 'never'.
        errors.length ? css.errorTextarea : css.textarea,
        textAreaClassName,
      )}
      {...props}
    />
    {/* @ts-expect-error - TS2339 - Property 'length' does not exist on type 'never'. */}
    {errors.length > 0 && <ErrorList className={css.errors} errors={errors} />}
  </div>
);

export default ErrorTextarea;
